import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {Filtro} from './filtro';
import {ProdutosService} from 'src/app/home/home/conteudo/produtos/produtos.service';
import {Produto} from 'src/app/home/home/conteudo/produtos/produto';
import {Page} from 'src/app/page';
import {Observable} from 'rxjs';

@Component({
    selector: 'store-pesquisa-filtros',
    templateUrl: './filtros.component.html',
    styleUrls: ['./filtros.component.scss']
})
export class FiltrosComponent implements OnInit {

    @Input()
    public filtro: Filtro;

    @Input()
    public produtos: Observable<Page<Produto>>;

    @Input()
    public tagsPesquisa: Array<string>;

    @Input()
    public filtros: Map<string, any>;
    @ViewChild('termoPesquisa', {static: false}) termoPesquisa: ElementRef;

    public termo: string;

    public valoresExplorar: Array<boolean> = [];

    public valoresTipo: Set<string> = new Set<string>();

    public valoresAreas: Set<string> = new Set<string>();

    public valoresDesenvolvedor: Set<string> = new Set<string>();

    public filterSidebarIsHidden: boolean;

    constructor(private produtosService: ProdutosService) {
        this.filterSidebarIsHidden = true;
    }

    ngOnInit() {
        this.inicializaValores();
    }

    private inicializaValores() {
        if (this.filtros.get('novidade')) {
            this.valoresExplorar.push(true);
        }
        if (this.filtros.get('ehMaisUtilizado')) {
            this.valoresExplorar.push(true);
        }
        if (this.filtros.get('areasNegocio')) {
            this.valoresAreas.add(this.filtros.get('areasNegocio')[0]);
        }
        if (this.filtros.get('plataformas')) {
            this.valoresTipo.add(this.filtros.get('plataformas')[0]);
        }
        if (this.filtros.get('desenvolvedores')) {
            this.valoresDesenvolvedor.add(this.filtros.get('desenvolvedores')[0]);
        }
    }

    public deleteTag(index): void {
        this.tagsPesquisa.splice(index, 1);
        this.produtos = this.produtosService.getProdutos(this.filtros, this.tagsPesquisa, 0, 20);
    }

    public filtrar(sessao, item): void {
        const itemMarcado = item.marcado === undefined ? true : !item.marcado;
        switch (sessao) {
            case 'EXPLORAR': {
                this.filtros.delete(item.coluna);
                if (itemMarcado) {
                    this.filtros.set(item.coluna, [true]);
                }
                break;
            }
            case 'AREAS': {
                this.getPreparaFiltro(itemMarcado, item.identificador, 'areasNegocio', this.valoresAreas);
                break;
            }
            case 'TIPO': {
                this.getPreparaFiltro(itemMarcado, item.chave.toLowerCase(), 'plataformas', this.valoresTipo);
                break;
            }
            case 'DESENVOLVEDOR': {
                this.getPreparaFiltro(itemMarcado, item.chave.toLowerCase(), 'desenvolvedores', this.valoresDesenvolvedor);
                break;
            }
            default: {
                break;
            }
        }
        this.produtos = this.produtosService.getProdutos(this.filtros, this.tagsPesquisa, 0, 20);
    }

    private getPreparaFiltro(itemMarcado: boolean, identificador: string, coluna: string, lista: Set<string>) {
        if (itemMarcado) {
            lista.add(identificador);
        } else {
            lista.delete(identificador);
        }
        this.filtros.delete(coluna);
        if (lista.size > 0) {
            this.filtros.set(coluna, Array.from(lista));
        }
    }

    public showFilterSidebar() {
        this.filterSidebarIsHidden = false;
    }

    public hideFilterSidebar() {
        this.filterSidebarIsHidden = true;
    }

    public getFiltersSize() {
        let totalSize: number;
        totalSize = 0;
        this.filtros.forEach(item => {
            totalSize += item.length;
        });
        return totalSize;
    }

}
